import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "How do I know how much paint I need?",
    answer:
      "Use our Paint Calculator to get an accurate estimate based on your wall size and number of coats. This ensures you buy just the right amount without wastage.",
  },
  {
    question: "How many coats of paint are recommended?",
    answer:
      "For the best coverage and finish, we recommend two coats of Glamur Paint after applying a suitable primer. This enhances color richness, durability, and evenness on every surface.",
  },
];

const rightColumn = [
  {
    question: "How long does Glamur Paint take to dry?",
    answer:
      "Glamur Paint typically dries to the touch within 30–60 minutes, depending on temperature and humidity. For recoating, allow 2–4 hours for optimal adhesion and a flawless finish.",
  },
  {
    question: "Do I need to apply primer before painting?",
    answer:
      "Yes, applying a primer is recommended, especially on new, unpainted, or repaired surfaces. Primer ensures better paint adhesion, enhances color brightness, and provides a smoother, long-lasting finish.",
  },
  {
    question: "Are Glamur Paints eco-friendly?",
    answer:
      "Absolutely. Glamur Paints are low-VOC, non-toxic, and environmentally safe, ensuring cleaner air quality and a healthier home environment without compromising performance or beauty.",
  },
];

const FAQestore = () => {
  // ✅ Open the first question (L0) by default
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Ask Questions</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQestore;
